<div
  class="p-[15px]"
  (mousemove)="moveEvent($event)"
  (mouseleave)="endGrabEvent($event)"
  (mouseup)="endGrabEvent($event)"
  [ngClass]="{'!cursor-grabbing': grabbedStatus > 0}"
  style="background-image: url('{{backgroundImage}}');background-position-x: center;">
  <div
    class="w-full grid gap-4 md:flex items-center justify-center md:justify-between mb-4"
  >
  <div class="w-full flex items-center justify-center md:justify-end">
      <div class="w-full flex items-center gap-4">
        <div
          (click)="weekly ? previousWeek() : previousMonth()"
          class="cursor-pointer"
        >
          <svg
            class="w-[20px] h-[20px]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
            />
          </svg>
        </div>
        <div class="font-medium text-xl leading-6 text-center text-large">
          {{ currentMonthToDisplay }}
        </div>
        <div (click)="nextWeek()" class="cursor-pointer">
          <svg
            class="w-[20px] h-[20px]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
            />
          </svg>
        </div>
      </div>
    </div>
    <!-- <div
      class="w-full mt-[5px] cursor-pointer flex flex-col md:!flex-row items-center justify-end font-bold text-font14px underline gap-2 text-base leading-5"
    >
      Crea evento
    </div> -->
    
  </div>
  <div class="rounded-xl w-full" [ngClass]="{'rounded-b-xl': weekly && scrollHours}">
    <div class="w-full hide-bar" [style]="'height: ' + scrollHours && weekly? ((hoursToScroll*50) + 'px') :'auto'" [ngClass]="{'flex': weeklyShowHoursMode == 'weekly' && weekly,'overflow-y-scroll':weekly &&scrollHours }">
      <div
        class="grid w-full gap-2.5 !rounded-xl md:!rounded-none"
        [style]="
          'grid-template-columns: repeat(' +
          7 +
          ', 1fr)'
        "
      >
    @for (day of generatedArrayCalendar; track $index;let index = $index) {
        <div
          class="text-[#102A35] w-full border-r-quaternary border-opacity-20 text-medium min-h-[180px]
            font-medium text-base leading-[19.5px] grid cursor-pointer bg-white"
          [ngClass]="{
            hidden: daysToRemove.includes(day.week),
            '!text-primary':
              daySelected &&
              daySelected.day === day.day &&
              !daysOff.includes(day.week),
            'min-h-[180px]': weekly,'!cursor-grabbing': grabbedStatus > 0,
            '!bg-opacity-25':backgroundImage,
            'border-r-[1px]':index < 6
          }"
          
          (click)="daysOff.includes(day.week) === true ? null : selectDay(day)"
          [id]="'calendar-day-' + day.month + '-' + day.week + '-' + day.day"
        > 
           <div class="text-font18px leading-[22px] h-[22px] text-quaternary mb-2.5">{{ translatePipe('daysOfTheWeek.' + (index + 1))}} {{day.day}}</div>
          
           <div>
            
            <div
              (click)="$event.stopPropagation();openEvent(event)"
              *ngFor="
                let event of weekly
                  ? day.events
                  : day.events.slice(0, showAllEvents ? day.events.length : 2);
                let i = index;
                let last = last
              "
              [title]="event.name"
              class="mb-2.5 items-end rounded-md whitespace-nowrap overflow-hidden pl-2 bg-primary"
              [id]="'calendar-event-id-' + event.id"
            >
             <div  class="text-font12px text-white font-medium">
                    {{ event.name }}
                    <br>
                    {{ getEventTime(event.startDate) }}
                  </div>
            </div>
          </div>


        </div>
      } 
      </div>
    </div>
  </div>

  <div></div>
</div>

<!-- dettaglio mobile -->

<div
  (click)="$event.stopPropagation()"
  *ngFor="let item of details; let i = index; let last = last"
  class="flex flex-col items-start justify-start w-full md:!hidden mt-5 gap-3"
>
  <div
    *ngFor="let event of item.events; let i = index; let last = last"
    (click)="showMore(event, i)"
  >
    <div class="w-full flex items-center justify-center gap-1">
      <div class="w-[4px] rounded-[5px] h-[30px] bg-primary"></div>
      <div class="w-full max-h-[30px] flex flex-col items-start justify-start">
        <div class="text-medium text-[#102A35] font-medium leading-[14.4px]">
          {{ getEventTime(event.dateStart) }}/ {{ getEventTime(event.dateEnd) }}
        </div>
        <div class="text-medium text-[#102A35] font-medium leading-[19.2px]">
          {{ event.name }}
        </div>
      </div>
    </div>

    <div
      class="w-full h-full flex flex-col items-start justify-start gap-5 mt-5"
      *ngIf="selectedIndex === i"
    >
      <!-- descrizione -->
      <div
        *ngFor="let mobileItem of mobileItems"
        class="w-full h-full flex flex-col gap-2 items-start justify-start"
      >
        <div class="text-base font-semibold leading-[19.2px] text-[#102A35]">
          {{ mobileItem.label }}
        </div>
        <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
          {{ event[mobileItem.value] }}
        </div>
      </div>
    </div>
    <div *ngIf="!last" class="py-2 w-full">
      <div class="w-full h-[3px] border bg-[#102A35] opacity-15"></div>
    </div>
  </div>
</div>
<!-- modale per calendario -->

<div
  *ngIf="show"
  (click)="closeOnOutside ? closeModal() : null"
  class="fixed top-0 left-0 z-[9999] h-screen  !w-screen bg-black !bg-opacity-30 md:!flex place-content-center items-center hidden"
>
  <div
    (click)="$event.stopPropagation()"
    class="'flex flex-col rounded-xl overflow-hidden ' + cardClass"
  >
    <ng-content select="[customModal]"></ng-content>
  </div>
</div>
